/* eslint-disable */
// @formatter:off
export const symspanDefinition = {
  steps: [
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'The Acumen assessment evaluates the ability to make judgments and quick decisions using memory, attention, and recall skills.',
          },
          {
            orderNum: 2,
            text: 'Below are some tips for completing this two-part cognitive assessment:',
            bullets: [
              'Find a quiet place and eliminate any distractions',
              'The tasks will require your complete attention',
              'If you exit the assessment, you will not be able to resume your place in the assessment',
              'Do NOT write anything down during the Acumen Test - doing so will invalidate your results',
            ],
          },
          {
            orderNum: 3,
            text: 'Take this assessment on a laptop or device with a large screen – the images used for this assessment are not mobile-friendly',
          },
          {
            orderNum: 4,
            text: 'Please click the CONTINUE button to proceed.',
          },
        ],
        isInput: false,
        btnText: 'Continue',
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'For this assessment, you will be asked to remember a sequence of blocks as they appear on a grid while making symmetry judgments about patterns.',
          },
          {
            orderNum: 2,
            text: 'For each trial:',
            bullets: [
              'You will see a pattern',
              'Then a sequence of blocks as they appear on a grid',
              'You will have to make judgments about the patterns and remember the sequence of blocks as they appear, in order, on the grid',
              'You will then be asked to recall the sequence of blocks on a grid in the order in which they appeared',
            ],
          },
          {
            orderNum: 3,
            text: 'Please click the CONTINUE button to proceed.',
          },
        ],
        isInput: false,
        btnText: 'Continue',
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'We will start by practicing the spatial memory portion of the assessment. Spatial locations within a grid will turn blue sequentially. Try to remember the locations in the order in which they appear.',
          },
          {
            orderNum: 2,
            text: '',
            bullets: [
              'On the test screen, there will be any empty grid',
              'Click the locations in the grid to report them',
              'Remember, it is very important to report the locations in the same order as you see them',
              'If you cannot remember a particular location, you can click the "blank" button to skip an entry',
              'If you make a mistake and want to start over, clicking the "clear" button will clear the screen',
              'When you are finished making your responses, click "submit"',
            ],
          },
          {
            orderNum: 3,
            text: 'Please click the START button to begin.',
          },
        ],
        isInput: false,
        btnText: 'Start',
      },
    },
    // Spatial location practice 1
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 7: true },
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 2: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: true,
        answers: [
          { index: 1, cell: 7 },
          { index: 2, cell: 2 },
        ],
      },
    },
    // Spatial location practice 2
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 5: true },
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 15: true },
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 9: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: true,
        answers: [
          { index: 1, cell: 5 },
          { index: 2, cell: 15 },
          { index: 3, cell: 9 },
        ],
      },
    },
    // Spatial location practice 3
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 3: true },
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 8: true },
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 14: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: true,
        answers: [
          { index: 1, cell: 3 },
          { index: 2, cell: 8 },
          { index: 3, cell: 14 },
        ],
      },
    },
    // Symmetry intro
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'That is the end of the location memory practice portion. Next, we will practice the symmetry portion of the task.',
            bullets: [
              'For each trial, you will see a pattern, and it may or may not be symmetrical',
              'Shown below is an example of a symmetrical pattern. The right and left sides of the pattern are identical',
            ],
          },
        ],
        grid: {
          cells: {
            1: 0,
            2: 0,
            3: 0,
            4: 1,
            5: 1,
            6: 0,
            7: 0,
            8: 0,
            9: 0,
            10: 0,
            11: 0,
            12: 1,
            13: 1,
            14: 0,
            15: 0,
            16: 0,
            17: 0,
            18: 0,
            19: 1,
            20: 1,
            21: 1,
            22: 1,
            23: 0,
            24: 0,
            25: 0,
            26: 1,
            27: 1,
            28: 1,
            29: 1,
            30: 1,
            31: 1,
            32: 0,
            33: 1,
            34: 1,
            35: 1,
            36: 1,
            37: 1,
            38: 1,
            39: 1,
            40: 1,
            41: 0,
            42: 1,
            43: 1,
            44: 0,
            45: 0,
            46: 1,
            47: 1,
            48: 0,
            49: 0,
            50: 0,
            51: 1,
            52: 1,
            53: 1,
            54: 1,
            55: 0,
            56: 0,
            57: 0,
            58: 0,
            59: 0,
            60: 1,
            61: 1,
            62: 0,
            63: 0,
            64: 0,
          },
          centerLine: true,
        },
        isInput: false,
        btnText: 'Continue',
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'Shown below is an example of an asymmetrical pattern. The right and left sides of the pattern are different.',
          },
        ],
        grid: {
          cells: {
            1: 1,
            2: 1,
            3: 1,
            4: 1,
            5: 1,
            6: 0,
            7: 1,
            8: 1,
            9: 0,
            10: 0,
            11: 1,
            12: 0,
            13: 0,
            14: 1,
            15: 1,
            16: 0,
            17: 1,
            18: 1,
            19: 0,
            20: 0,
            21: 0,
            22: 0,
            23: 1,
            24: 0,
            25: 0,
            26: 1,
            27: 1,
            28: 1,
            29: 1,
            30: 1,
            31: 1,
            32: 1,
            33: 0,
            34: 1,
            35: 1,
            36: 1,
            37: 1,
            38: 1,
            39: 1,
            40: 1,
            41: 1,
            42: 1,
            43: 0,
            44: 0,
            45: 0,
            46: 0,
            47: 1,
            48: 0,
            49: 0,
            50: 0,
            51: 1,
            52: 0,
            53: 0,
            54: 1,
            55: 1,
            56: 0,
            57: 1,
            58: 1,
            59: 1,
            60: 1,
            61: 1,
            62: 0,
            63: 1,
            64: 1,
          },
          centerLine: true,
        },
        isInput: false,
        btnText: 'Continue',
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'Here is another example of a symmetrical pattern.',
          },
        ],
        grid: {
          cells: {
            1: 1,
            2: 1,
            3: 1,
            4: 1,
            5: 1,
            6: 1,
            7: 1,
            8: 1,
            9: 0,
            10: 0,
            11: 1,
            12: 1,
            13: 1,
            14: 1,
            15: 0,
            16: 0,
            17: 0,
            18: 0,
            19: 0,
            20: 1,
            21: 1,
            22: 0,
            23: 0,
            24: 0,
            25: 0,
            26: 0,
            27: 1,
            28: 1,
            29: 1,
            30: 1,
            31: 0,
            32: 0,
            33: 0,
            34: 0,
            35: 1,
            36: 0,
            37: 0,
            38: 1,
            39: 0,
            40: 0,
            41: 0,
            42: 0,
            43: 1,
            44: 0,
            45: 0,
            46: 1,
            47: 0,
            48: 0,
            49: 0,
            50: 0,
            51: 1,
            52: 1,
            53: 1,
            54: 1,
            55: 0,
            56: 0,
            57: 0,
            58: 1,
            59: 0,
            60: 1,
            61: 1,
            62: 0,
            63: 1,
            64: 0,
          },
        },
        isInput: false,
        btnText: 'Continue',
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'Here is another example of an asymmetrical pattern.',
          },
        ],
        grid: {
          cells: {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            6: 0,
            7: 0,
            8: 1,
            9: 1,
            10: 1,
            11: 0,
            12: 0,
            13: 0,
            14: 0,
            15: 1,
            16: 1,
            17: 1,
            18: 1,
            19: 1,
            20: 0,
            21: 0,
            22: 1,
            23: 1,
            24: 1,
            25: 1,
            26: 1,
            27: 1,
            28: 1,
            29: 1,
            30: 1,
            31: 0,
            32: 1,
            33: 1,
            34: 0,
            35: 0,
            36: 0,
            37: 0,
            38: 0,
            39: 0,
            40: 1,
            41: 1,
            42: 0,
            43: 1,
            44: 1,
            45: 1,
            46: 1,
            47: 1,
            48: 1,
            49: 1,
            50: 1,
            51: 1,
            52: 0,
            53: 0,
            54: 1,
            55: 1,
            56: 1,
            57: 1,
            58: 1,
            59: 0,
            60: 0,
            61: 0,
            62: 0,
            63: 1,
            64: 1,
          },
        },
        isInput: false,
        btnText: 'Continue',
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'We will now practice the symmetry portion. When you have made your symmetry judgment, click TRUE if the pattern is symmetrical, click FALSE if it is not.',
          },
          {
            orderNum: 2,
            text: 'Please click the CONTINUE button to proceed.',
          },
        ],
        isInput: false,
        btnText: 'Continue',
      },
    },
    // Symmetry practice 1 (pracsymm12)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 0,
          5: 0,
          6: 1,
          7: 1,
          8: 1,
          9: 1,
          10: 0,
          11: 1,
          12: 0,
          13: 0,
          14: 1,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 1,
          25: 1,
          26: 0,
          27: 1,
          28: 0,
          29: 0,
          30: 1,
          31: 1,
          32: 0,
          33: 1,
          34: 0,
          35: 1,
          36: 0,
          37: 0,
          38: 1,
          39: 1,
          40: 0,
          41: 1,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 1,
          49: 1,
          50: 0,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 1,
          60: 0,
          61: 0,
          62: 1,
          63: 1,
          64: 1,
        },
        displayResult: true,
        isSymmetrical: false,
        timed: false,
      },
    },
    // Symmetry practice 2 (pracsymm9)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 1,
          9: 1,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 1,
          20: 0,
          21: 0,
          22: 1,
          23: 1,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 1,
          41: 1,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 1,
          56: 1,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: true,
        isSymmetrical: false,
        timed: false,
      },
    },
    // Symmetry practice 3 (pracsymm7)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 1,
          12: 0,
          13: 0,
          14: 1,
          15: 1,
          16: 0,
          17: 0,
          18: 0,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 0,
          24: 0,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          41: 0,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 0,
          48: 0,
          49: 0,
          50: 1,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: true,
        isSymmetrical: true,
        timed: false,
      },
    },
    // Combined practice intro
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'We will now practice the combined task.',
          },
          {
            orderNum: 2,
            text: 'As a reminder.',
            bullets: [
              'You will get a pattern',
              'Then one of the locations on the grid will flash blue',
              'This pattern will repeat',
              'At the end of the list, you will recall the locations in the same order in which they appeared',
            ],
          },
          {
            orderNum: 3,
            text: 'Judgments on symmetry patterns are timed. If you take longer than the allotted time to judge the pattern, the judgment will be skipped and proceed to show a location. The missed judgement will be counted as an error. Make your judgments as quickly and accurately as possible',
          },
          {
            orderNum: 4,
            text: 'Please click the CONTINUE button to proceed.',
          },
        ],
        isInput: false,
        btnText: 'Continue',
      },
    },
    // Combined practice 1
    // (pracsymm10)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 0,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 0,
          8: 1,
          9: 1,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 1,
          16: 1,
          17: 1,
          18: 0,
          19: 1,
          20: 0,
          21: 1,
          22: 1,
          23: 0,
          24: 1,
          25: 1,
          26: 0,
          27: 1,
          28: 1,
          29: 0,
          30: 1,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 1,
          41: 1,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 0,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 1,
          57: 0,
          58: 0,
          59: 1,
          60: 0,
          61: 0,
          62: 1,
          63: 0,
          64: 0,
        },
        displayResult: true,
        isSymmetrical: false,
        timed: true,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 7: true },
      },
    },
    // (pracsymm3)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 0,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 1,
          21: 1,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 1,
          36: 0,
          37: 0,
          38: 1,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 1,
          44: 0,
          45: 0,
          46: 1,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 0,
          56: 0,
          57: 0,
          58: 1,
          59: 0,
          60: 1,
          61: 1,
          62: 0,
          63: 1,
          64: 0,
        },
        displayResult: true,
        isSymmetrical: true,
        timed: true,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 1: true },
      },
    },
    // (pracsymm5)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 1,
          25: 0,
          26: 0,
          27: 0,
          28: 1,
          29: 1,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 1,
          37: 1,
          38: 0,
          39: 0,
          40: 0,
          41: 1,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 1,
        },
        displayResult: true,
        isSymmetrical: true,
        timed: true,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 11: true },
      },
    },
    // Symmetry practice 1 (pracsymm8)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 0,
          11: 1,
          12: 0,
          13: 0,
          14: 1,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 1,
          24: 0,
          25: 0,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 0,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          41: 1,
          42: 1,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 0,
          49: 0,
          50: 0,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: true,
        isSymmetrical: false,
        timed: true,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 9: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: true,
        answers: [
          { index: 1, cell: 7 },
          { index: 2, cell: 1 },
          { index: 3, cell: 11 },
          { index: 4, cell: 9 },
        ],
      },
    },
    // Actual trial
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'We will now start the scored trial. Note: The practice rounds displayed your result values. In this scored trial, your results will not be displayed.',
          },
          {
            orderNum: 3,
            text: 'Please click the CONTINUE button to proceed.',
          },
        ],
        isInput: false,
        btnText: 'Continue',
      },
    },
    // Trial 1
    // (symm48)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 0,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 0,
          18: 1,
          19: 1,
          20: 0,
          21: 0,
          22: 0,
          23: 1,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 0,
          29: 0,
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 0,
          37: 0,
          38: 1,
          39: 1,
          40: 1,
          41: 0,
          42: 1,
          43: 1,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 0,
          57: 0,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 1,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 7: true },
      },
    },
    // (symm23)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 0,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 0,
          8: 0,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 0,
          18: 0,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 0,
          24: 0,
          25: 1,
          26: 1,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 1,
          32: 1,
          33: 0,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 0,
          41: 0,
          42: 1,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 0,
          49: 0,
          50: 0,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 0,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 1,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 15: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 1,
        answers: [
          { index: 1, cell: 7 },
          { index: 2, cell: 15 },
        ],
      },
    },
    // Trial 2
    // (symm25)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 0,
          3: 0,
          4: 1,
          5: 1,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 1,
          12: 1,
          13: 1,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 0,
          24: 0,
          25: 0,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 0,
          33: 0,
          34: 1,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 1,
          40: 0,
          41: 0,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 0,
          49: 0,
          50: 0,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 1,
          61: 1,
          62: 1,
          63: 0,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 2,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 4: true },
      },
    },
    // (symm20)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 0,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 0,
          8: 0,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          41: 1,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 1,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 0,
          57: 0,
          58: 0,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 0,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 2,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 8: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 2,
        answers: [
          { index: 1, cell: 4 },
          { index: 2, cell: 8 },
        ],
      },
    },
    // Trial 3
    // (symm39)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 0,
          4: 0,
          5: 1,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 0,
          12: 1,
          13: 1,
          14: 0,
          15: 1,
          16: 0,
          17: 0,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 1,
          29: 1,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 1,
          37: 1,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 0,
          49: 0,
          50: 1,
          51: 0,
          52: 1,
          53: 1,
          54: 0,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 1,
          61: 0,
          62: 0,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 3,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 6: true },
      },
    },
    // (symm19)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 1,
          10: 0,
          11: 0,
          12: 1,
          13: 1,
          14: 0,
          15: 0,
          16: 1,
          17: 0,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 0,
          25: 0,
          26: 1,
          27: 0,
          28: 1,
          29: 1,
          30: 0,
          31: 1,
          32: 0,
          33: 0,
          34: 1,
          35: 0,
          36: 1,
          37: 1,
          38: 0,
          39: 1,
          40: 0,
          41: 0,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 0,
          49: 1,
          50: 0,
          51: 0,
          52: 1,
          53: 1,
          54: 0,
          55: 0,
          56: 1,
          57: 1,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 3,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 13: true },
      },
    },
    // (symm46)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 1,
          6: 0,
          7: 0,
          8: 0,
          9: 1,
          10: 1,
          11: 0,
          12: 0,
          13: 1,
          14: 0,
          15: 1,
          16: 1,
          17: 0,
          18: 0,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 0,
          24: 0,
          25: 1,
          26: 1,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 1,
          40: 1,
          41: 0,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 0,
          48: 0,
          49: 1,
          50: 1,
          51: 0,
          52: 1,
          53: 0,
          54: 0,
          55: 1,
          56: 1,
          57: 1,
          58: 1,
          59: 0,
          60: 1,
          61: 0,
          62: 0,
          63: 0,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 3,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 14: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 3,
        answers: [
          { index: 1, cell: 6 },
          { index: 2, cell: 13 },
          { index: 3, cell: 14 },
        ],
      },
    },
    // Trial 4
    // (symm11)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 1,
          9: 1,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 1,
          20: 0,
          21: 0,
          22: 1,
          23: 1,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 1,
          41: 1,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 1,
          56: 1,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 4,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 13: true },
      },
    },
    // (symm18)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 1,
          25: 0,
          26: 0,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 0,
          41: 1,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        scored: true,
        trial: 4,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 3: true },
      },
    },
    // (symm14)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 1,
          8: 1,
          9: 1,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 1,
          17: 1,
          18: 0,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 0,
          24: 1,
          25: 0,
          26: 0,
          27: 1,
          28: 0,
          29: 0,
          30: 1,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 0,
          41: 1,
          42: 1,
          43: 1,
          44: 0,
          45: 0,
          46: 1,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 1,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 4,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 12: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 4,
        answers: [
          { index: 1, cell: 13 },
          { index: 2, cell: 3 },
          { index: 3, cell: 12 },
        ],
      },
    },
    // Trial 5
    // (symm6)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 1,
          9: 1,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 1,
          25: 1,
          26: 0,
          27: 1,
          28: 0,
          29: 0,
          30: 1,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 1,
          36: 0,
          37: 0,
          38: 1,
          39: 0,
          40: 1,
          41: 1,
          42: 0,
          43: 1,
          44: 0,
          45: 0,
          46: 1,
          47: 0,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 1,
          57: 1,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 5,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 15: true },
      },
    },
    // (symm38)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 1,
          7: 1,
          8: 1,
          9: 1,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 1,
          28: 0,
          29: 0,
          30: 1,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 1,
          36: 0,
          37: 0,
          38: 1,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 1,
          57: 1,
          58: 1,
          59: 1,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 5,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 7: true },
      },
    },
    // (symm32)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 0,
          9: 1,
          10: 0,
          11: 0,
          12: 0,
          13: 1,
          14: 0,
          15: 0,
          16: 1,
          17: 1,
          18: 0,
          19: 0,
          20: 0,
          21: 1,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 1,
          41: 1,
          42: 0,
          43: 0,
          44: 1,
          45: 0,
          46: 0,
          47: 0,
          48: 1,
          49: 1,
          50: 0,
          51: 0,
          52: 1,
          53: 0,
          54: 0,
          55: 0,
          56: 1,
          57: 0,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 5,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 13: true },
      },
    },
    // (symm36)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 1,
          4: 0,
          5: 0,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 1,
          12: 0,
          13: 1,
          14: 1,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 1,
          24: 1,
          25: 0,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 0,
          33: 0,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 0,
          41: 1,
          42: 1,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 1,
          53: 0,
          54: 1,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 5,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 4: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 5,
        answers: [
          { index: 1, cell: 15 },
          { index: 2, cell: 7 },
          { index: 3, cell: 13 },
          { index: 4, cell: 4 },
        ],
      },
    },
    // Trial 6
    // (symm44)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 1,
          9: 0,
          10: 0,
          11: 1,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 1,
          21: 0,
          22: 1,
          23: 0,
          24: 0,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          41: 0,
          42: 0,
          43: 1,
          44: 0,
          45: 1,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 1,
          55: 0,
          56: 0,
          57: 1,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 6,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 14: true },
      },
    },
    // (symm17)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 0,
          9: 1,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 1,
          16: 1,
          17: 1,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 0,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 0,
          41: 0,
          42: 1,
          43: 0,
          44: 1,
          45: 1,
          46: 0,
          47: 1,
          48: 0,
          49: 0,
          50: 1,
          51: 0,
          52: 1,
          53: 1,
          54: 0,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 6,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 4: true },
      },
    },
    // (symm41)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 1,
          10: 0,
          11: 0,
          12: 1,
          13: 0,
          14: 0,
          15: 0,
          16: 1,
          17: 1,
          18: 1,
          19: 0,
          20: 0,
          21: 1,
          22: 0,
          23: 1,
          24: 1,
          25: 0,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 0,
          33: 0,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 0,
          41: 0,
          42: 1,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 0,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 6,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 6: true },
      },
    },
    // (symm12)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 1,
          12: 0,
          13: 0,
          14: 1,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 1,
          24: 1,
          25: 0,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 0,
          33: 0,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 0,
          41: 1,
          42: 1,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 6,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 13: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 6,
        answers: [
          { index: 1, cell: 14 },
          { index: 2, cell: 4 },
          { index: 3, cell: 6 },
          { index: 4, cell: 13 },
        ],
      },
    },
    // Trial 7
    // (symm37)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 0,
          3: 0,
          4: 1,
          5: 1,
          6: 0,
          7: 0,
          8: 0,
          9: 1,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 1,
          25: 0,
          26: 0,
          27: 0,
          28: 1,
          29: 1,
          30: 0,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 0,
          41: 1,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 1,
          57: 0,
          58: 0,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 0,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 7,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 10: true },
      },
    },
    // (symm26)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 1,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 1,
          20: 1,
          21: 1,
          22: 1,
          23: 1,
          24: 1,
          25: 0,
          26: 1,
          27: 0,
          28: 1,
          29: 1,
          30: 0,
          31: 1,
          32: 0,
          33: 1,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          41: 1,
          42: 0,
          43: 0,
          44: 1,
          45: 1,
          46: 0,
          47: 0,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 1,
          57: 0,
          58: 1,
          59: 1,
          60: 0,
          61: 0,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 7,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 7: true },
      },
    },
    // (symm28)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 0,
          3: 1,
          4: 1,
          5: 0,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 0,
          20: 0,
          21: 1,
          22: 0,
          23: 1,
          24: 1,
          25: 1,
          26: 0,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 1,
          41: 1,
          42: 1,
          43: 0,
          44: 0,
          45: 1,
          46: 0,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 0,
          57: 0,
          58: 0,
          59: 1,
          60: 1,
          61: 0,
          62: 0,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 7,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 13: true },
      },
    },
    // (symm30)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 1,
          9: 1,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 1,
          20: 0,
          21: 0,
          22: 0,
          23: 1,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 0,
          29: 0,
          30: 0,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 0,
          37: 0,
          38: 0,
          39: 1,
          40: 1,
          41: 1,
          42: 1,
          43: 1,
          44: 0,
          45: 0,
          46: 0,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 1,
          57: 1,
          58: 1,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 7,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 14: true },
      },
    },
    // (symm1)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 0,
          20: 1,
          21: 1,
          22: 0,
          23: 1,
          24: 1,
          25: 1,
          26: 0,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 0,
          40: 1,
          41: 1,
          42: 1,
          43: 0,
          44: 1,
          45: 1,
          46: 0,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 0,
          57: 1,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 7,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 9: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        trial: 7,
        answers: [
          { index: 1, cell: 10 },
          { index: 2, cell: 7 },
          { index: 3, cell: 13 },
          { index: 4, cell: 14 },
          { index: 5, cell: 9 },
        ],
      },
    },
    // Trial 8
    // (symm45)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 0,
          3: 1,
          4: 0,
          5: 0,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 0,
          11: 1,
          12: 0,
          13: 0,
          14: 1,
          15: 1,
          16: 1,
          17: 1,
          18: 1,
          19: 1,
          20: 0,
          21: 0,
          22: 1,
          23: 1,
          24: 1,
          25: 1,
          26: 0,
          27: 0,
          28: 1,
          29: 1,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 1,
          37: 1,
          38: 0,
          39: 0,
          40: 1,
          41: 1,
          42: 1,
          43: 1,
          44: 0,
          45: 0,
          46: 1,
          47: 1,
          48: 1,
          49: 1,
          50: 1,
          51: 1,
          52: 0,
          53: 0,
          54: 1,
          55: 0,
          56: 0,
          57: 1,
          58: 1,
          59: 1,
          60: 0,
          61: 0,
          62: 1,
          63: 0,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 8,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 12: true },
      },
    },
    // (symm4)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 1,
          24: 1,
          25: 1,
          26: 0,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 0,
          32: 1,
          33: 1,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 1,
          41: 1,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 0,
          48: 1,
          49: 1,
          50: 1,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 1,
          56: 1,
          57: 0,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 8,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 4: true },
      },
    },
    // (symm35)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 0,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 0,
          8: 1,
          9: 0,
          10: 1,
          11: 0,
          12: 1,
          13: 1,
          14: 0,
          15: 1,
          16: 0,
          17: 1,
          18: 0,
          19: 1,
          20: 0,
          21: 1,
          22: 1,
          23: 0,
          24: 1,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 1,
          36: 1,
          37: 1,
          38: 1,
          39: 1,
          40: 1,
          41: 1,
          42: 0,
          43: 1,
          44: 1,
          45: 0,
          46: 1,
          47: 0,
          48: 1,
          49: 0,
          50: 1,
          51: 0,
          52: 1,
          53: 1,
          54: 0,
          55: 1,
          56: 0,
          57: 1,
          58: 0,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 0,
          64: 1,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 8,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 9: true },
      },
    },
    // (symm27)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 1,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 1,
          9: 0,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 1,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 1,
          21: 1,
          22: 0,
          23: 0,
          24: 0,
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
          30: 1,
          31: 1,
          32: 0,
          33: 0,
          34: 0,
          35: 1,
          36: 0,
          37: 0,
          38: 1,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 1,
          44: 1,
          45: 1,
          46: 1,
          47: 0,
          48: 0,
          49: 0,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 1,
          57: 0,
          58: 0,
          59: 0,
          60: 1,
          61: 1,
          62: 0,
          63: 0,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: false,
        timed: true,
        trial: 8,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 15: true },
      },
    },
    // (symm9)
    {
      type: 'SYMMETRY_GRID',
      props: {
        cells: {
          1: 0,
          2: 1,
          3: 1,
          4: 1,
          5: 1,
          6: 1,
          7: 1,
          8: 0,
          9: 0,
          10: 1,
          11: 1,
          12: 1,
          13: 1,
          14: 1,
          15: 1,
          16: 0,
          17: 1,
          18: 1,
          19: 1,
          20: 0,
          21: 0,
          22: 1,
          23: 1,
          24: 1,
          25: 1,
          26: 1,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 1,
          40: 1,
          41: 1,
          42: 1,
          43: 1,
          44: 0,
          45: 0,
          46: 1,
          47: 1,
          48: 1,
          49: 0,
          50: 1,
          51: 1,
          52: 1,
          53: 1,
          54: 1,
          55: 1,
          56: 0,
          57: 0,
          58: 1,
          59: 1,
          60: 1,
          61: 1,
          62: 1,
          63: 1,
          64: 0,
        },
        displayResult: false,
        isSymmetrical: true,
        timed: true,
        trial: 8,
      },
    },
    {
      type: 'BLOCK_FLASHCARD',
      props: {
        activeItems: { 2: true },
      },
    },
    {
      type: 'BLOCK_RECALL',
      props: {
        key: 'BLOCK_RECALL',
        displayResult: false,
        submitResults: true,
        complete: true,
        trial: 8,
        answers: [
          { index: 1, cell: 12 },
          { index: 2, cell: 4 },
          { index: 3, cell: 9 },
          { index: 4, cell: 15 },
          { index: 5, cell: 2 },
        ],
      },
    },
  ],
};
